import { useTranslation } from 'react-i18next'
import { useDeleteTourMutation } from '@/entities/tour'
import { DeleteButtonWithConfirm } from '@/shared/ui/delete-button-with-confirm'

interface TourDeleteButtonProps {
  tourId: string
}

export function TourDeleteButton({ tourId }: TourDeleteButtonProps) {
  const { t } = useTranslation()
  const mutation = useDeleteTourMutation()

  return (
    <DeleteButtonWithConfirm
      onDelete={async () => {
        await mutation.mutateAsync(tourId)
      }}
      isPending={mutation.isPending}
      confirmTitle={t('tour.deleteConfirm')}
      successMessage={t('tour.deleteSuccess')}
    />
  )
}
